import { Guid } from '@web/utils';

export class PublicCheckoutSubmitSuccessEvent {
  public constructor(
    private readonly data: {
      orderId: Guid;
      accessToken: string;
    },
  ) {}

  public get orderId(): Guid {
    return this.data.orderId;
  }

  public get accessToken(): string {
    return this.data.accessToken;
  }
}
